module.exports = __webpack_public_path__ + "static/media/mockQR.f22fb7a0.webp";